import React from 'react';
import styles from './styles';
import {Button, Icons, SearchBar} from "@xpertdox_js/xdcomponents";
import axiosConfig from "../../../config/axios.config";
import {InstanceContext} from "../../../InstanceContext";
import axios from "axios";

const RequestForm = props => {
  const [showForm, setShowForm] = React.useState(false)
  const {contextInstance} = React.useContext(InstanceContext);
  const [terms, setTerms] = React.useState(false)
  const callControl = React.useRef({
    getTerms: false,
    hasChanged: false
  })

  if(!terms && !callControl.current.getTerms) {
    callControl.current.getTerms = true
    axios.get(`${axiosConfig.apiUrl}/rt/get-suggested-terms/${props.instance}/${props.nct}`).then(sT => {
      setTerms(sT.data)
    })
  }

  const addCondition = (term) => {
    console.log(term, 'term')
    let isActive = false;
    if(props.activeTerms) isActive = props.activeTerms.find(t => t.name1_key === term.name1key)
    if(!isActive){
      let newTerms = terms ? [...terms] : []
      newTerms.push(term)
      setTerms(newTerms)
      callControl.current.hasChanged = true
    }
  }

  const removeTerm = (index) => {
    let newTerms = [...terms];
    newTerms.splice(index, 1);
    callControl.current.hasChanged = true
    setTerms(newTerms)
  }

  const submit = () => {
    axios.post(
      `${axiosConfig.apiUrl}/rt/suggest-terms/${props.instance}/${props.nct}/${props.email}`,
      {terms}
    ).then(response => {
      callControl.current.hasChanged = false;
      callControl.current.getTerms = false;
      setTerms(false)
    })
  }

  const toggle = () => {
    if(showForm) {
      callControl.current.getTerms = false
      setTerms(false)
    }
    callControl.current.hasChanged = false
    setShowForm(!showForm)
  }


  return <div style={styles.container}>
    <div style={props.styles.nct}>
      {terms.length > 0 && terms.map((term, index) => {
        let btnStyles = props.styles.nctContainer
        if(term.excluded || callControl.current.hasChanged) btnStyles = {
          ...btnStyles,
          ...props.styles.excluded
        }
        return <Button
          key={index}
          id={`nct_${index}`}
          styles={{...btnStyles, marginBottom: 15}}
          hoverStyles={props.styles.nctHover}
        >
          {term.url_name}
          <Icons
            onClick={() => removeTerm(index)}
            icon='circleX'
            style={{...props.styles.icon, marginLeft: 5}}
          />
        </Button>
      })}
    </div>
    {showForm && <React.Fragment>
      <SearchBar
        context={{instance: contextInstance}}
        axiosConfig={{
          ...axiosConfig,
          auth: {
            headers: {
              ...axiosConfig.auth.headers,
              "Authorization": axiosConfig.token
            }
          }
        }}
        type="diseases"
        selected={addCondition}
        index='master'
      />
    </React.Fragment>}
    <div style={styles.btnContainer}>
      {
        callControl.current.hasChanged && <Button
          styles={styles.btn}
          onClick={() => submit()}>Save</Button>
      }
      <Button
        styles={{...styles.btn, ...styles.btnC}}
        onClick={() => toggle()}>{showForm ? 'Cancel' : 'Suggest a Condition'}
      </Button>
    </div>
    <p style={{
      color: 'rgb(208, 87, 85)',
      margin: '5px 2px 5px',
      fontSize: 11
    }}>*These conditions will be added in the next weekly update</p>
  </div>
}

export default RequestForm
